<template>
  <div>
		<transition
			enter-active-class="animated slideInLeft2"
			leave-active-class="animated slideInRight2"
			v-on:after-enter="onenterPhone"
		>
		<login-phone
			ref="loginphone"
			v-show="showPhone"
			:phone="phone"
			:region="region"
			:codes="codes"
			:tipsText="tipsText"
			:nextText="nextText"
			@setPhone= "setPhone"
		>
			<slot name="phoneheader"></slot>
		</login-phone>
		</transition>
		<transition
			enter-active-class="animated slideInLeft"
			leave-active-class="animated slideInRight"
			v-on:after-enter ="onenterCode"
		>
		<login-code
			ref="logincode"
			v-show="showCode"
			:phone="phone"
			:region="region"
			:isReg="isReg"
			:mobile="mobile"
			:loginText="loginText"
            :validate="validate"
			@setSign = "setSign"
			@back = "onBack"
		>
		</login-code>
		</transition>
    <div id="captcha"></div>
    <div @touchstart.stop.prevent :style="cStyle" class="login-appendWrap" id="appendWrap"></div>
  </div>

</template>

<script>
const CAPTCHLIMITIME = 2 * 60 * 1000 // 2分钟
const CAPTCHMAXLENGTH = 7  // 最多检测次数
import _ from '@/utils/util'
import loginPhone from './phone'
import loginCode from './code'
import api from '@/api'
import windowEvent from '@/plugins/window'
import { mapGetters } from 'vuex'
export default {
    name: 'login',
    props: {
      mobile: Boolean,
      qrcode: String,
      sourceType: String,
      tipsText: String,
      nextText: String,
      loginText: String
    },
    data () {
      return {
        captchaIns: null, // urs易盾
        sowCaptch: false, // 显示易盾
        validate: '',     // 易盾的validate
        captchaErrNum: 0, // 易盾出错限制次数
        captchaTime: 0,   // 易盾出错限制时间
        isReg: false,
        top: 0,
        showPhone: true,
        showCode: false,
        phone: '',
        region: '',
        codes: []
      }
    },
    created () {
      this.phone = this.$storage.get('NCG-phone')
      this.region = this.$storage.get('NCG-phone-region') || '86'
      this.getCtcodes()
    },
    components: {
      loginPhone,
      loginCode
    },
    computed: {
      ...mapGetters([
        'devInfo'
      ]),
      cStyle () {
        return {
          visibility: this.sowCaptch ? 'inherit' : 'hidden'
        }
      }
    },
    watch: {
    },
    methods: {
      reset () {
        this.showPhone = true
        this.showCode = false
        this.$refs.logincode.reset()
        console.log('reset')
      },
      setPhone (options = {}) {
        this.phone = options.phone
        this.region = options.region
        this.validate = ''
        this.check(this.region, this.phone)
      },
      warnVerify (msg) {
        const top = this.getTop()
        this.$toast({
          top: top,
          type: 'warn',
          text: msg || '您的验证操作过于频繁，请稍后再试~'
        })
      },
      check (ctcode, phone) {
        /* 判断手机是否有注册
        * 1.若是验证次数过多，则限制一下频率,并提醒，本地默认时间是2分钟
        * 2.所有的参数去验证是否要开启用户行为判断
        */
        if (this.captchaErrNum && this.captchaTime && (+new Date - this.captchaTime) < CAPTCHLIMITIME) {
          this.warnVerify()
          return
        }
        this.$http.get(api.getRegistered(ctcode, phone), {
          params: _.searchToObject()
        }).then(() => {
          // 已有帐号，需要去登录，不做易盾验证的
          this.toShowCode(true)
        }, (err) => {
          console.log('出错异常', err)
          const status = err.status
          const data = err.data || {}
          const errcode = data.errcode
          // 去注册
          if (status == 404) {
            // 需要去易盾验证
            if (errcode == 1120) {
              this.captchaErrNum = 0
              this.captchaTime = 0
              this.onInitNECaptcha()
              return
            }
            // 号码易盾校验太多次了,待等处理
            if (errcode == 1121) {
              this.warnVerify()
              return
            }
            // 不需要验证，提示去注册
            this.toShowCode()
            return true
          }
          // 提示出错
          this.$refs.loginphone.setError(data.errmsgcn)
        })
      },
      toShowCode (hasReg) {
        this.isReg = !!hasReg
        this.showPhone = false
        this.sowCaptch = false
        this.showCode = true
        this.$emit('setReg',hasReg ? '登录' : '注册并登录')
      },
      onInitNECaptcha () {
        // 已存在易盾
        if (this.captchaIns && this.captchaIns.popUp) {
          this.sowCaptch = true
          this.captchaIns.refresh()
          this.captchaIns.popUp()
          return
        }
        // 若使用降级方案引用初始化js
        window.initNECaptcha({
          captchaId: process.env.VUE_APP_CAPTCHAID,
          element: '#captcha',
          mode: 'popup',
          appendTo: '#appendWrap',
          width: '300px',
          onVerify:  (err, data) => {
            // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
            if (err) {
              this.captchaErrNum++
              // 超过N次则不让去验证了
              if (this.captchaErrNum >= CAPTCHMAXLENGTH) {
                this.warnVerify()
                this.sowCaptch = false
                this.captchaTime = +new Date()
                // 标记已出错N次，不可再进行验证
                this.$http.get(api.getRegistered(this.region, this.phone), {
                  params: {
                    limit_time: 1
                  }
                }).then(() =>{}, () => {})
              }
              return
            }  
            console.log('验证成功:', data)
            this.validate = data.validate
            this.toShowCode()
          },
          onClose: () => {
            this.sowCaptch = false
          }
        }, (instance) => {
          this.sowCaptch = true
          this.captchaIns = instance
          this.captchaIns.popUp()
        }, (err) => {
          // 初始化失败后触发该函数，err对象描述当前错误信息
          console.log('注册失败', err)
          this.warnVerify('网络异常，请稍后重试~【' +  err.code + '】')
        })
      },
      onenterPhone () {
        this.$refs.loginphone.$el.querySelector('input').focus()
      },
      onenterCode () {
        this.$refs.logincode.$el.querySelector('input').focus()
        this.$refs.logincode.getAuthcode()
      },
      setSign (data) {
        const captcha = data.captcha  // 测试环境会返回
        const code = data.code
        console.log('登录时提交的设备信息', this.devInfo)
        const params = {
          auth_method: "phone-captcha",
          ctcode: '' + this.region,
          phone: this.phone,
          captcha: captcha || code,
          device_info: this.devInfo
        }

        // 二维码id存存，进行TV绑定
        if (this.qrcode) {
          params.qrcode_id = this.qrcode
        }

        // 活动登录时区分类型
        if (this.sourceType) {
          params.source_type = this.sourceType
        }

        if (window.NG_ACTIVITY && window.NG_ACTIVITY.campaign) {
          const projectId = _.getQuerys('project_id') || this.$storage.get('NCG-client-projectid');
          params.project_id = projectId;

          params.extra = {
            invite_id: window.NG_ACTIVITY.invite.invite_id,
            campaign: window.NG_ACTIVITY.campaign
          };
        }
        //邀请注册
        let invite_code = _.getQuerys('invite_code')
        if(params.extra){
          params.extra.invite_code = invite_code
        }else{
          params.extra = {
            invite_code : invite_code
          }
        }

        this.$store.dispatch('getToken', params).then((res) => {
          this.$storage.set('NCG-phone-region', this.region)
          this.$storage.set('NCG-phone', this.phone)
          this.$emit('login', this.isReg,res)
          windowEvent.emit({
            label: 'getUser'
          })
        }, () => {
          this.$refs.logincode.tip = '验证码错误'
        })
      },
      onBack () {
        this.showCode = false
        this.showPhone = true
      },
      getTop () {
        // 移动端
        if (this.mobile) {
          // 横屏
          if (Math.abs(window.orientation) == 90) {
            return 0
          }
          return -1
        }
        // pc端
        const $el = this.$parent.$el.querySelector('.cofirm-cont')
        if (!$el) {
          return 0
        }
        var clientRects = $el.getClientRects()[0]
        return clientRects.top + clientRects.height + 16
      },
      getCtcodes () {
        this.$store.dispatch('getCtcodes').then((res) => {
          console.log('获取到的列表')
          this.codes = res
        }, () => {})
      }
    },
    mounted () {
      const back = this.mobile && this.$storage.get('NCG-back')
      if (back) {
        this.setPhone({
          phone: this.phone,
          region: this.region
        })
        this.$storage.remove('NCG-back')
      } else {
        this.onenterPhone()
      }
    },
    destroyed () {
      this.captchaIns && this.captchaIns.destroy && this.captchaIns.destroy()
      this.captchaIns = null
    }
}
</script>
